import { DateWithSession } from '@eventbrite/checkout-fairy-api';
import { EventStatus } from '../../../constants/eventStatus';

export const isEventSoldOut = (
    eventEndDate: string,
    eventDates: DateWithSession[],
): boolean => {
    if (!eventEndDate || !eventDates || eventDates.length === 0) {
        return false;
    }

    const eventEndDateString = eventEndDate.split('T')[0];
    let isEndDateFound = false;

    for (let dateIndex = 0; dateIndex < eventDates.length; dateIndex++) {
        const sessions = eventDates[dateIndex].sessions;
        for (
            let sessionIndex = 0;
            sessionIndex < sessions.length;
            sessionIndex++
        ) {
            if (sessions[sessionIndex].availability === EventStatus.available) {
                return false;
            }

            if (
                sessions[sessionIndex].startDatetime?.split('T')[0] ===
                eventEndDateString
            ) {
                isEndDateFound = true;
            }
        }
    }

    return isEndDateFound;
};
